import PropTypes from 'prop-types';

import GenericFormContainer from '../Forms/GenericFormContainer';

import { lengthValidation60, required, validateIP } from '../Forms/utils';

import { STYLED_TEXT } from '../Forms/fieldTypes';

const IPManagementFormComponent = ({
  initialValues,
  onSubmit,
  form,
  existingIpRanges,
}) => {
  const formData = [
    {
      label: 'Start IP',
      keyName: 'start_ip',
      fieldType: STYLED_TEXT,
      validate: [required, validateIP],
    },
    {
      label: 'End IP',
      keyName: 'end_ip',
      fieldType: STYLED_TEXT,
      validate: [required, validateIP],
    },
    {
      label: 'Name',
      keyName: 'name',
      fieldType: STYLED_TEXT,
      validate: [required, lengthValidation60],
    },
  ];

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      initialValues={initialValues}
      onSubmit={onSubmit}
      title="Add new IP"
      canBeUpdated
      existingIpRanges={existingIpRanges}
      enableReinitialize
    />
  );
};

IPManagementFormComponent.propTypes = {
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  onSubmit: PropTypes.func.isRequired,
  existingIpRanges: PropTypes.instanceOf(Array).isRequired,
};

export default IPManagementFormComponent;
